/* eslint-disable */
import useSWR from 'swr';
import { useState } from 'react';
import { Nav, NavbarForm } from './styles';
import { fetcher } from '../../../service/SWRFetcher';
import { Box } from '@material-ui/core';
import UserForm from '../../UserForm';

const DatePeriodFilter = ({ setFilters, filters, mutate }) => {
  const { data: users, isValidating } = useSWR(`/users`, fetcher);

  const [open, setOpen] = useState(false);

  function handleSubmit(event) {
    event.preventDefault();
    setFilters((f) => ({ ...f, ...filt }));
  }

  const handleChange = (e) => {
    setFilt({ ...filters, [e.target.name]: e.target.value });
  };

  const [filt, setFilt] = useState({
    name: '',
    login: '',
    status: '',
  });

  const handleOpenCreate = async (item) => {
    setOpen(!open);
  };

  return (
    <Nav>
      <UserForm open={open} setOpen={setOpen} title={'Criar Usuário'} mutate={mutate} create />

      <div className="filter">Filtros</div>
      <NavbarForm>
        <form className="form" onSubmit={handleSubmit}>
          <div className="client">
            <input
              list="select"
              name="name"
              className="select-form"
              placeholder="Usuário"
              value={filt.name}
              onChange={handleChange}
              disabled={isValidating}
            />
            <datalist id="select">
              {users?.map((item) => (
                <option key={item.id} value={item.name}>
                  {' '}
                </option>
              ))}
            </datalist>
          </div>
          <div className="login">
            <input
              name="login"
              className="select-form"
              placeholder="Login"
              value={filt.login}
              onChange={handleChange}
            />
          </div>
          <div className="login">
            <select
              name="status"
              className="select-form"
              placeholder="Ativo?"
              value={filt.status}
              onChange={handleChange}>
              <option defaultChecked value="">
                Status
              </option>
              <option value="1">Ativos</option>
              <option value="0">Inativos</option>
            </select>
          </div>

          <div>
            <button className="button" onClick={() => setFilt({ name: '', login: '' })}>
              Limpar
            </button>
            <button className="button" type="submit">
              Filtrar
            </button>
          </div>

          <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginRight: '12px' }}>
            <button className="button" type="button" onClick={handleOpenCreate}>
              Cadastrar
            </button>
          </Box>
        </form>
      </NavbarForm>
    </Nav>
  );
};

export default DatePeriodFilter;
